import type { PublicSlotKey } from '#packages/apilib';
import type { ResizeGapsApi } from './resizeGapsApi';

export const ResizeGapsApiKey: PublicSlotKey<ResizeGapsApi> = {
  name: 'ResizeGapsApi',
  public: true,
};
